import React from 'react';

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  align?: 'left' | 'center';
  light?: boolean;
}

export const SectionHeading: React.FC<SectionHeadingProps> = ({ 
  title, 
  subtitle, 
  align = 'center',
  light = false 
}) => {
  return (
    <div className={`mb-16 ${align === 'center' ? 'text-center' : 'text-left'}`}>
      <h2 className={`text-3xl md:text-5xl font-black mb-6 tracking-tight ${light ? 'text-white' : 'text-brand-dark'}`}>
        {title}
      </h2>
      {subtitle && (
        <div className={`h-1.5 w-24 bg-brand-orange mb-6 ${align === 'center' ? 'mx-auto' : ''}`}></div>
      )}
      {subtitle && (
        <p className={`text-lg md:text-xl font-medium max-w-3xl ${align === 'center' ? 'mx-auto' : ''} ${light ? 'text-gray-100' : 'text-gray-600'}`}>
          {subtitle}
        </p>
      )}
    </div>
  );
};